var _ellipse, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.045,
    cy: 13.9902,
    rx: 12.102,
    ry: 12.0992,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8915 14.003C22.8915 11.8482 21.148 10.105 18.9926 10.105C16.8373 10.105 15.0937 11.8482 15.0937 14.003H15.0809L15.4025 17.3221L14 18.3191L12.5781 17.3221L12.8998 14.003H12.8869C12.8869 11.8482 11.1434 10.105 8.98802 10.105C7.07076 10.105 5.47517 11.488 5.14705 13.3148C5.12773 13.5463 5.11487 13.7715 5.11487 14.0095C5.11487 18.9109 9.10384 22.8925 14 22.8925C18.9026 22.8861 22.8915 18.898 22.8915 14.003ZM11.0018 14.003C11.0018 15.1223 10.0947 16.0292 8.97516 16.0292C7.85568 16.0292 6.94852 15.1223 6.94852 14.003C6.94852 12.8838 7.85568 11.9768 8.97516 11.9768C10.1011 11.9768 11.0018 12.8838 11.0018 14.003ZM21.0128 14.003C21.0128 15.1223 20.1057 16.0292 18.9862 16.0292C17.8667 16.0292 16.9595 15.1223 16.9595 14.003C16.9595 12.8838 17.8667 11.9768 18.9862 11.9768C20.1057 11.9768 21.0128 12.8838 21.0128 14.003Z",
    fill: "url(#paint0_linear_1_596)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9871 10.5295C15.0873 8.9472 16.9145 7.91159 18.9926 7.91159C19.5846 7.91159 20.1507 7.99522 20.6912 8.15602C19.057 6.29064 16.6636 5.11353 14 5.11353C11.3428 5.11353 8.95589 6.28421 7.32812 8.14316C7.8557 7.99522 8.409 7.91159 8.98162 7.91159C11.0533 7.91159 12.8869 8.9472 13.9871 10.5295Z",
    fill: "url(#paint1_linear_1_596)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 -0.000183105C6.26654 -0.000183105 0 6.27135 0 14.003C0 21.7347 6.26654 27.9998 14 27.9998C21.7335 27.9998 28 21.7347 28 14.003C28 6.27135 21.7335 -0.000183105 14 -0.000183105ZM14 25.1053C7.86213 25.1053 2.88879 20.1331 2.88879 13.9966C2.88879 13.958 2.88879 13.9194 2.88879 13.8808C2.95313 7.80225 7.90074 2.88794 13.9936 2.88794C20.1314 2.88794 25.1048 7.86014 25.1048 13.9966C25.1112 20.1331 20.1379 25.1053 14 25.1053Z",
    fill: "url(#paint2_linear_1_596)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_596",
    x1: 22.8895,
    y1: 16.4937,
    x2: 5.11314,
    y2: 16.4937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD352E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1345,
    stopColor: "#DC302C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#DA2728"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92427"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_596",
    x1: 20.6862,
    y1: 7.82295,
    x2: 7.32752,
    y2: 7.82295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD352E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1345,
    stopColor: "#DC302C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#DA2728"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92427"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_596",
    x1: 28.0027,
    y1: 14.0006,
    x2: 0,
    y2: 14.0006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD352E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1345,
    stopColor: "#DC302C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5533,
    stopColor: "#DA2728"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92427"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9691709b46633f032f2699aa53b302dd.svg";
export { ForwardRef as ReactComponent };